export default "__VITE_ASSET__36b72f99__"